import Page404 from "../pages/Page404";
export const AppRoutes = [
  {
    path: "/",
    name: "index",
    redirect: { name: "auth.login" },
    meta: { requiresAuth: false }
  },
  {
    path: "*",
    name: "404",
    component: Page404,
    meta: { requiresAuth: false }
  }
];
